export const STICKER_CATEGORIES = {
	all: "All",
	// v0.4.0
	// logos: "Logos",
	flags: "Flags",
	shapes: "Shapes",
	emojis: "Emojis",
};
